<script setup>
import { defineProps } from "vue";

const props = defineProps({
    text: {
        type: String,
        required: true
    },
    size:{
        type: String,
        default: 'lg'
    }
});

const getButtonClass = () => {
    return props.size === 'sm' ? 'btn-small' : '';
};
</script>

<template>
    <button :class="`btn btn-purple w-100 ${getButtonClass()}`" type="button">
        {{ text }}
    </button>
</template>

<style scoped>
.btn-purple {
    background: linear-gradient(90deg, #9203DD 0%, #4F0277 100%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 9px;
    font-family: 'Space Grotesk';
    font-size: 24px;
    font-weight: bold;
}
.btn-small {
    font-size: 16px;
    padding: 8px 0;
}
</style>
